import React from "react";
import { useIntl, defineMessages } from "react-intl";
import ExpandableCard from "theme/components/molecules/Card/ExpandableCard/ExpandableCard";
import IconButton from "theme/components/atoms/Button/IconButton";

const messages = defineMessages({
  reset: {
    id: "modules.Layer.Facet.reset",
    defaultMessage: "Remove all filters for {label}",
  },
});

const Facet = ({
  label,
  children,
  expandedInitially,
  activeFiltersCount,
  onReset,
}) => {
  const intl = useIntl();
  return (
    <ExpandableCard
      expandedInitially={expandedInitially}
      preview={() => (
        <span className="facet">
          <span className="facet__label">{label}</span>
          {activeFiltersCount > 0 ? (
            <span className="facet__count">({activeFiltersCount})</span>
          ) : null}
          {/* The hidden tricks allow to keep the exact same height regardless of the status */}
          <span className="facet__reset" aria-hidden={activeFiltersCount === 0}>
            <IconButton
              icon="cross"
              onClick={
                onReset
                  ? (event) => {
                      event.preventDefault();
                      event.stopPropagation();
                      onReset();
                    }
                  : undefined
              }
              title={intl.formatMessage(messages.reset, { label: label })}
            ></IconButton>
          </span>
        </span>
      )}
      children={() => children}
    />
  );
};

export default Facet;
